export const FETCH_CONTEXT = 'FETCH_CONTEXT';
export const FETCH_CONTEXT_FULFILLED = 'FETCH_CONTEXT_FULFILLED';
export const FETCH_CONTEXT_REJECTED = 'FETCH_CONTEXT_REJECTED';
